import { FC, useState } from 'react';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { pageAnimation } from '@const/animation';
import { motion } from 'framer-motion';
import Typography from '@components/common/typography';
import VerificationCode from '@components/verification_code';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    onSubmit: () => void;
    onPrev: () => void;
    onChange: (val: string) => void;
    value?: string;
    isLoading?: boolean;
}

const Verify: FC<IProps> = ({ onSubmit, onPrev, onChange, value, isLoading }) => {
    const { submitLocale } = useLocales();
    const [isError, setIsError] = useState(false);
    return (
        <div className={styles.main_wrapper}>
            <motion.div {...pageAnimation} className={styles.wrapper}>
                <div className={styles.text_wrapper}>
                    <Typography weight="semibold" variant="body1" className={styles.title}>
                        Enter the 6-digit code from your authenticator app
                    </Typography>
                    <Typography variant="body2" className={styles.description}>
                        To confirm setup, enter the current verification code generated by your
                        authenticator app. Make sure you use the code that's specifically for your
                        XEPPT account.
                    </Typography>
                </div>
                <VerificationCode onChange={onChange} error={isError} />
                <div className={styles.actions}>
                    <Button leftIcon="arrow_left" variant="outlined-primary" onClick={onPrev}>
                        {submitLocale('previous')}
                    </Button>
                    <Button
                        rightIcon="arrow_right"
                        variant="primary"
                        isLoading={isLoading}
                        onClick={() => {
                            if (value?.length !== 6) {
                                setIsError(true);
                            } else {
                                onSubmit();
                            }
                        }}>
                        {submitLocale('verify')}
                    </Button>
                </div>
            </motion.div>
        </div>
    );
};

export default Verify;
